var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(0.46875 0.728516)",
    fill: "url(#pattern0_194_1325)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_194_1325",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_194_1325",
    transform: "scale(0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_194_1325",
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAAW9yTlQBz6J3mgAAAAFzUkdCAK7OHOkAAADESURBVEjHY2AYBUMQpO9IW0oVg9L+p70dxgatYk6LSp+UviFtIxguTavIUiHDoPRvaReBxqHA9B8ZZaS7CATPpmdk+EBhWPrUtF9AwxJJNih9RwMLqmiGD1D8FbooYRe1pydiwPtAC9qwiGOBmZ7/GRnQQ4c8mGENCuwfabMpgjfT/mf6USEdpc8bNYj+BqX/Tj9ECUx7AXMRFSDERR+zrCiBaVsGa2B/TX9EYRk7GWiQC7DkyXCi0CC5tGySSq5RMGgAALXKYQ813iUaAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.656851ef8de46a20c88cf1f0008c3056.svg";
export { ForwardRef as ReactComponent };